import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/app/java-full-stack-with-gen-ai/components/ProgramInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/common/Header.tsx");
